import { SET_MODE } from '../actions/types';

export const modeReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_MODE:
      return { loading: false, data: action.payload };

    default:
      return state;
  }
};
